<script setup lang="ts">
/**
 * Singbac — Undertaking by Client (Annex A · Resident Director 보호 각서). company/client 단위 1부.
 * "Singbac", "Singbac Management Services Pte. Ltd." 는 리터럴 텍스트(변수 아님).
 */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <p class="doc-lbl-title">Annex A – Undertaking by Client</p>

    <div class="doc-sec-title">SINGBAC PTE. LTD.</div>

    <p class="doc-p"><b>Date:</b> <CddVarField field-key="undertaking_date" label="Undertaking Date" /></p>

    <p class="doc-lbl-title">Undertaking towards Resident Director</p>

    <p class="doc-p">Dear Mr. <CddVarField field-key="client_name" label="Client Name" />,</p>
    <p class="doc-p">
      This undertaking serves to provide protection and assurance to Singbac for the duration of service provided to
      <CddVarField field-key="company_name" label="Company Name" /> (the "Company") in the capacity of Resident Director.
      We set out the following clauses below for your perusal: -
    </p>

    <p class="doc-p">
      We are fully aware that ACRA will disqualify a Director if its filing regulations are breached as stated in Section
      155 of the Companies Act.
    </p>
    <p class="doc-p">
      We accept that Mr. <CddVarField field-key="resident_director_name" label="Resident Director Name" /> serving as a
      Resident Director bears a level of risk while providing the service to the Company in the event that the Company is
      non-compliant with ACRA's filing regulations and laws and its officers become uncontactable for an extended period.
    </p>
    <p class="doc-p">
      In the light of this risk, the Company and its officers will ensure that all compliances that are required by all
      government bodies to which it has dealings in Singapore are duly and routinely met.
    </p>
    <p class="doc-p">
      We will ensure that the Company and its officers will maintain consistent contact with Singbac and the appointed
      agent (Singbac Management Services Pte. Ltd.) in order to enable smooth resolution of any issues that may arise in
      future, including work towards ensuring compliance for the Company and termination of services by any party (Client,
      Singbac or the Resident Director).
    </p>
    <p class="doc-p">
      Where the Client and the Company and its officers are not contactable via registered post, email or telephone for a
      period of more than 2 months where there is a pending compliance issue in the Company, we accept that we will be
      given 30 days' notice from the end of that period to remedy the compliance issue or arrange for a replacement
      Resident Director to take the place of Mr. <CddVarField field-key="resident_director_name" label="Resident Director Name" />.
      If there is no resolution after 30 days, the Resident Director will move forward to deregister the company via ACRA
      to ensure that ACRA's Filing regulations are not breached as stated in Section 155 of the Companies Act. This is
      done as a last resort to ensure that the Resident Director is not disqualified due to non-compliance.
    </p>
    <p class="doc-p">
      Where the Client and Company and its officers are consistently contactable but refuse to adhere to a termination of
      service raised by either Singbac of the Resident Director, we accept that we will be given 30 days' notice to remedy
      the issue that gave rise to the termination request or arrange for a replacement Resident Director to take the place
      of Singbac. If there is no resolution after the 30 days' notice period, the Resident Director will move forward to
      deregister the Company via ACRA to ensure that ACRA's filing regulations are not breached as stated in Section 155
      of the Companies Act. This is done as a last resort to ensure that the Resident Director is not disqualified due to
      non-compliance.
    </p>
    <p class="doc-p">
      We will enter into mediation to resolve any conflicts between Singbac, the Resident Director and the Company amicably
      and without incident where possible.
    </p>
    <p class="doc-p">
      All acts required to be done by the Resident Director in his/her capacity as Resident Director shall comply with all
      laws affecting or binding on the Company and its officers.
    </p>
    <p class="doc-p">
      All statements and documents that the Company and it officers, requests the Resident Director to sign are true and
      accurate.
    </p>
    <p class="doc-p">
      We undertake that the Company shall not use or quote the Resident Director's name in any document or transaction
      without his/her prior written consent;
    </p>
    <p class="doc-p">
      We undertake that the Company shall keep proper accounts and will file all tax returns and all papers and documents
      which are required by law to be paid by the Company shall be paid.
    </p>
    <p class="doc-p">
      The undertakings and obligations on our part herein contained shall be binding on our executors, administrators and
      successors in title.
    </p>

    <p class="doc-p">
      This Undertaking is taken to be an addendum and part of the Resident Director Service Agreement to which the Client,
      Company, Resident Director and Singbac are a party to.
    </p>

    <p class="doc-p">For and on behalf of :</p>

    <p class="doc-p">The Company : __________________________<br />Name: <CddVarField field-key="client_name" label="Client Name" /></p>
    <p class="doc-p">The Client : __________________________<br />Name: <CddVarField field-key="client_name" label="Client Name" /></p>
    <p class="doc-p">Resident Director: __________________________<br />Name: <CddVarField field-key="resident_director_name" label="Resident Director Name" /></p>
  </div>
</template>

<style scoped>
.doc-lbl-title { font-weight: 800; margin: 14px 0 6px; }
</style>
